import React from 'react';
import 'react-tooltip/dist/react-tooltip.css';

import { Form, Formik } from 'formik';

import Loader from '@/components/commons/loader';
import ToggleButton from '@/components/forms/toggle_button';
import styles from './Agendas.module.css';

interface Props {
    readonly isLoading: boolean;
    readonly isError: boolean;
    readonly onChange: () => void;
    readonly vacationMode: boolean;
}

function VacationModeToggle({
    isLoading, isError, onChange, vacationMode,
}: Props) {
    return (
        <Loader isLoading={isLoading} isError={isError}>
            <div className={styles.topBar}>
                <div>
                    <Formik
                        onSubmit={() => { }}
                        initialValues={{
                            vacationMode: Boolean(vacationMode),
                        }}
                    >
                        <Form>
                            <ToggleButton
                                onChange={onChange}
                                checked={Boolean(vacationMode)}
                                name="vacationMode"
                            />
                        </Form>
                    </Formik>
                </div>
                <div className="text-[14px]">
                    <span className="font-bold">Vacation mode.</span>
                    {' '}
                    Temporarily disable all agendas.
                </div>
            </div>
        </Loader>
    );
}

export default VacationModeToggle;
